/* ==========================================================================
   Mirah — rails.js
   Product card rails (Swiper core). Markup:
   [data-rail-wrap] > .swiper[data-rail] + [data-rail-prev]/[data-rail-next]
   ========================================================================== */
(function () {
  'use strict';
  if (window.MirahRails) return;

  var d = document;
  var rem = function () { return parseFloat(getComputedStyle(d.documentElement).fontSize) || 16; };

  function setState(sw, prev, next) {
    if (prev) { prev.classList.toggle('swiper-button-disabled', sw.isBeginning); prev.setAttribute('aria-disabled', sw.isBeginning); }
    if (next) { next.classList.toggle('swiper-button-disabled', sw.isEnd); next.setAttribute('aria-disabled', sw.isEnd); }
  }

  // Rails are set up lazily as they approach the viewport to keep start-up work low.
  var lazy = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      lazy.unobserve(en.target);
      create(en.target);
    });
  }, { rootMargin: '600px 0px' }) : null;

  function init(root) {
    if (!window.Swiper) return;
    (root || d).querySelectorAll('[data-rail]').forEach(function (el) {
      if (el.swiper || el._railQueued) return;
      el._railQueued = true;
      if (lazy) lazy.observe(el); else create(el);
    });
  }

  function create(el) {
    (function () {
      if (el.swiper) return;
      var wrap = el.closest('[data-rail-wrap]') || el.parentElement;
      var prev = wrap.querySelector('[data-rail-prev]');
      var next = wrap.querySelector('[data-rail-next]');
      // Right-to-left rails (the mirrored Explore rows) advance leftwards, so the left-pointing button is "next".
      if (el.getAttribute('dir') === 'rtl' && prev && next) {
        var t = prev; prev = next; next = t;
        var label = prev.getAttribute('aria-label');
        prev.setAttribute('aria-label', next.getAttribute('aria-label'));
        next.setAttribute('aria-label', label);
      }
      var mobileStack = el.hasAttribute('data-rail-stack-mobile') && window.innerWidth < 768;
      if (mobileStack) return;
      var sw = new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: rem() * (window.innerWidth < 768 ? 1 : 1.5),
        speed: 900,
        grabCursor: true,
        watchOverflow: true,
        resistanceRatio: 0.6,
        on: {
          init: function (s) { setState(s, prev, next); },
          slideChange: function (s) { setState(s, prev, next); },
          reachEnd: function (s) { setState(s, prev, next); },
          reachBeginning: function (s) { setState(s, prev, next); },
          resize: function (s) { s.params.spaceBetween = rem() * (window.innerWidth < 768 ? 1 : 1.5); s.update(); }
        }
      });
      // Swiper re-runs update() as lazy card images load, and update() snaps back to the active slide — which
      // yanked the rail home in the middle of a drag. Hold updates while a drag or slide is in progress.
      var update = sw.update.bind(sw);
      var pending = false, timer;
      var flush = function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          if (sw.destroyed) return;
          if (sw.animating || (sw.touchEventsData && sw.touchEventsData.isTouched)) return flush();
          if (pending) { pending = false; update(); }
        }, 120);
      };
      sw.update = function () {
        if (sw.animating || (sw.touchEventsData && sw.touchEventsData.isTouched)) { pending = true; flush(); return; }
        return update();
      };
      sw.on('transitionEnd', flush);
      if (prev) prev.addEventListener('click', function () { sw.slidePrev(); });
      if (next) next.addEventListener('click', function () { sw.slideNext(); });
      // Keep keyboard users oriented: bring focused slides into view.
      el.addEventListener('focusin', function (e) {
        var slide = e.target.closest('.swiper-slide');
        if (slide) sw.slideTo(Array.prototype.indexOf.call(sw.slides, slide));
      });
    })();
  }

  window.MirahRails = { init: init };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
